(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Register",
            {
                url: "/Register?state={currentToken}&authToken={token}&exists={userExists}",
                component: "register",
                resolve: {
                    onBefore: ["$stateParams", "userRegistrationApi", "$state", function ($stateParams, userRegistrationApi, $state) {
                        userRegistrationApi.getUserRegistrationByToken($stateParams.state).then(function (ur) {
                            if (Date.parse(ur.ExpirationDate) < Date.now()) {
                                $state.go("Invalid", { param: "expired" });
                            }
                            if (ur.Completed) {
                                $state.go("Login");
                            }
                        }, function () { $state.go("Invalid", { param: "expired" }); });
                    }],
                    userRegistration: ["$stateParams", "userRegistrationApi", function ($stateParams, userRegistrationApi) {
                        return userRegistrationApi.getUserRegistrationByToken($stateParams.state);
                    }]
                }
            });
    }]);

    app.component("register",
        {
            templateUrl: "/App/Register/register-template.html",
            controller: registerController,
            bindings: {
                userRegistration: "<"
            }

        });

    registerController.$inject = ["$stateParams", "AuthService", "baseApiUrl"];
    function registerController($stateParams, AuthService, baseApiUrl) {
        var $ctrl = this;

        window.location.href = baseApiUrl + "/Login/FigAuth/Registration?returnUrl=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host + "/#/Dashboard")
            + "&crmToken=" + window.encodeURIComponent($stateParams.state)
            + "&figAuthToken=" + window.encodeURIComponent($stateParams.authToken);
    }

})(window.app, window.angular);